<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
// import gql from "graphql-tag";
// import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import formEdit from './add'
// import moment from "moment-timezone";
// import md5 from 'js-md5'
export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Thêm mới unit",
      mode: 'add',
      models: {},
      images: [],
      oldImages: [],
      componentKey: 0,
      page_transaction:null,
      id:null
    }
  },
  async mounted () {
    // console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'editUnit' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Chỉnh sửa unit' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_USER);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-unit' });
    },
    convertPhone(numberPhone) {
      var phone = numberPhone
      if (numberPhone[0] === '0') {
        phone = phone.substring(1);
      }
      phone = phone.replace(' ', '')
      phone = '+84' + phone
      return phone
    },
    async getTotalCount() {
      if (!this.$commonFuction.isEmptyObject(this.farm)) {
        try {
          const gqLQueryCount = DataServices.countData("cs_unit");
          const where = {
            farm_id: { _eq: this.farm.id }, 
          };

          const countRes = await this.$apollo.mutate({
            mutation: gqLQueryCount,
            variables: { where_key: where },
          });

          const total =
            countRes.data["cs_unit_aggregate"]["aggregate"]["count"] + 1;

          return total >= 10 ? total : `0${total}`;
        } catch (error) {
          console.error("Error in getTotalCount:", error);
          return "01";
        }
      } else {
        console.warn("Farm is not selected");
        return "01";
      }
    },
    async saveData(params) {
      if (params !== undefined && Object.entries(params).length > 0) {
        var objects = {
          // name: params.name,
          volume: params.volume,
          // block: params.block,
          // box: params.box,
          // user: params.user,
          dimensions: params.dimensions,
          active: params.active,
          company_id: params.company_id, // Remove company_id here
        }
        
        var that = this;

        if (this.mode === 'add') {
          let success = [];
          let addEquiment = false;
          let addType = false;
          let addUser = false;
          var unit_id = this.$commonFuction.generateUUID();
          var total = await this.getTotalCount();
          var farmNameArr = params.farm.name.split(" ");
          var farmCodeArr = farmNameArr.map(m => m.charAt(0).toUpperCase());
          objects.code = `${farmCodeArr.join('')}UNT${total}`;
          objects.unit_id = unit_id;
          objects.column = params.column,
          objects.row = params.row;
          objects.farm_id = params.farm?.id;
          for(let b=0; b < params.block; b++) {
            objects.box = params.row * params.column;
            objects.name = `${params.name} - Block ${this.$constants.LIST_ALPHABET[b]}`;
            objects.ordinal = (b+1);
            await this.$apollo.mutate({
              mutation: DataServices.insertData('unit'),
              variables: {
                objects: objects
              }
            }).then(async (res) => {
              if (res.data[Object.keys(res.data)].affected_rows) {
                var returning = res.data[Object.keys(res.data)].returning[0];

                var listBox = [];
                for (let h=1; h <= params.row; h++) {
                  for (let c=1; c <= params.column; c++) {
                    listBox.push({
                      row_number: h,
                      column_number: c,
                      unit_id: returning.id,
                      code: `${params.name}${this.$constants.LIST_ALPHABET[b]} - H${ (h<10 ? '0'+h : h) } - C${ (c<10 ? '0'+c : c) }`
                    })
                  }
                }
                await this.$apollo.mutate({
                  mutation: DataServices.insertData('farm_has_unit'),
                  variables: {
                    objects: {
                      farm_id: params.farm?.id,
                      unit_id: returning.id,
                      active: true,
                    }
                  }
                }).catch(async error => {
                    console.log('error', error);
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                        life: 3000
                    });
                    this.$commonFuction.is_loading(false);
                });
                let variables__ = {
                    objects: listBox
                };
                await this.$apollo.mutate({
                    mutation: DataServices.insertData('obj_box'),
                    variables: variables__
                }).then(() => {
                  success.push(returning);
                  if (success.length == params.block && addEquiment && addType) {
                    this.redirectEdit();
                  }
                })
              } else {
                that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
                });
                this.$commonFuction.is_loading(false);
              }
            }).catch(async error => {
              console.log('error', error);
              that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
              });
              this.$commonFuction.is_loading(false);
              // this.summitEvent = false;
            });
          }
          let objectType = [];
          for (let i=0; i < params.equipment.length; i++) {
            objectType.push({
              unit_id: unit_id,
              equipment_id: params.equipment[i].id
            })
          }
          let variables = {
              objects: objectType
          };
          await this.$apollo.mutate({
              mutation: DataServices.insertData('equipment_has_units'),
              variables: variables
          }).then(() => {
            addEquiment = true;
            if (success.length == params.block && addEquiment && addType) {
              this.redirectEdit();
            }
          }).catch(async error => {
              console.log('error', error);
              this.$toast.add({
                  severity: 'error',
                  summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
              });
              this.$commonFuction.is_loading(false);
          });

          let _objectType_ = [];
          for (let i=0; i < params.user.length; i++) {
            _objectType_.push({
              unit_id: unit_id,
              user_id: params.user[i]
            })
          }
          let variables_user = {
              objects: _objectType_
          };
          await this.$apollo.mutate({
              mutation: DataServices.insertData('unit_has_users'),
              variables: variables_user
          }).then(() => {
            addUser = true;
            if (success.length == params.block && addUser) {
              this.redirectEdit();
            }
          }).catch(async error => {
              console.log('error', error);
              this.$toast.add({
                  severity: 'error',
                  summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
              });
              this.$commonFuction.is_loading(false);
          });

          let objectType_ = [];
          for (let i=0; i < params.kindtype.length; i++) {
            objectType_.push({
              unit_id: unit_id,
              kind_type_id: params.kindtype[i].id
            })
          }
          let variables_ = {
              objects: objectType_
          };
          await this.$apollo.mutate({
              mutation: DataServices.insertData('unit_has_kind_types'),
              variables: variables_
          }).then(() => {
            addType = true;
            if (success.length == params.block && addType) {
              this.redirectEdit();
            }
          }).catch(async error => {
              console.log('error', error);
              this.$toast.add({
                  severity: 'error',
                  summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
              });
              this.$commonFuction.is_loading(false);
          });
        //EDIT
        } else  {
          let success = [];
          let addEquiment = false;
          let addType = false;
          let addUser = false;
          for(let b=0; b < params.block; b++) {
            let variables = {
              'data_update': objects,
              'where_key': {
                'unit_id': {'_eq': this.models.id}
              }
            }
            objects.box = params.row * params.column;
            objects.name = `${params.name} - Block ${this.$constants.LIST_ALPHABET[b]}`;
            objects.ordinal = (b+1);
            await this.$apollo.mutate({
              mutation: DataServices.updateData('unit'),
              variables: variables
            }).then(async (res) => {
              if (res.data[Object.keys(res.data)].affected_rows) {
                var returning = res.data[Object.keys(res.data)].returning[0];
                success.push(returning);
                if (success.length == params.block && addEquiment && addType) {
                  this.redirectEdit();
                }
              } else {
                that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
                });
                this.$commonFuction.is_loading(false);
              }
            }).catch(async error => {
              console.log('error', error);
              that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
              });
              this.$commonFuction.is_loading(false);
              // this.summitEvent = false;
            });
          }
          await this.$apollo.mutate({
            mutation: DataServices.deleteData('equipment_has_units'),
            variables: {
                'where_key': {
                    'unit_id': {'_eq': this.models.id}
                }
            }
          })
          let objectType = [];
          for (let i=0; i < params.equipment.length; i++) {
            objectType.push({
              unit_id: this.models.id,
              equipment_id: params.equipment[i].id
            })
          }
          let variables_ = {
              objects: objectType
          };
          await this.$apollo.mutate({
              mutation: DataServices.insertData('equipment_has_units'),
              variables: variables_
          }).then(() => {
            addEquiment = true;
            if (success.length == params.block && addEquiment && addType) {
              this.redirectEdit();
            }

            
          }).catch(async error => {
              console.log('error', error);
              this.$toast.add({
                  severity: 'error',
                  summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
              });
              this.$commonFuction.is_loading(false);
          });

          await this.$apollo.mutate({
            mutation: DataServices.deleteData('unit_has_users'),
            variables: {
                'where_key': {
                    'unit_id': {'_eq': this.models.id}
                }
            }
          })
          let _objectType_ = [];
          for (let i=0; i < params.user.length; i++) {
            _objectType_.push({
              unit_id: this.models.id,
              user_id: params.user[i]
            })
          }
          let variables_user = {
              objects: _objectType_
          };
          await this.$apollo.mutate({
              mutation: DataServices.insertData('unit_has_users'),
              variables: variables_user
          }).then(() => {
            addUser = true;
            if (success.length == params.block && addUser) {
              this.redirectEdit();
            }
          }).catch(async error => {
              console.log('error', error);
              this.$toast.add({
                  severity: 'error',
                  summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
              });
              this.$commonFuction.is_loading(false);
          });
          

          await this.$apollo.mutate({
            mutation: DataServices.deleteData('unit_has_kind_types'),
            variables: {
                'where_key': {
                    'unit_id': {'_eq': this.models.id}
                }
            }
          })
          let objectType_ = [];
          for (let i=0; i < params.kindtype.length; i++) {
            objectType_.push({
              unit_id: this.models.id,
              kind_type_id: params.kindtype[i].id
            })
          }
          let variables__ = {
              objects: objectType_
          };
          await this.$apollo.mutate({
              mutation: DataServices.insertData('unit_has_kind_types'),
              variables: variables__
          }).then(() => {
            addType = true;
            if (success.length == params.block && addType) {
              this.redirectEdit();
            }
          }).catch(async error => {
              console.log('error', error);
              this.$toast.add({
                  severity: 'error',
                  summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
              });
              this.$commonFuction.is_loading(false);
          });
        }
      }
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-unit'};
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        that.$router.push(router_back);
      }else{
        if (!that.$commonFuction.isEmpty(router_back)){
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('cs_unit'),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
      // console.log('this.models hereeeeeeeeeeeeeeeeeeeeeee', this.models);  
    },

  },
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 5px; padding: 0;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
<style>
.list-group-v {
  /* display: -webkit-box;
   display: -ms-flexbox;*/
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /*-ms-flex-direction: column;*/
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item-v:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.list-group-item-v {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125) ;
  height: 50px;
}
.box-check-box{
  position: relative;
}
.box-check-box label{
  position: absolute;
  left: 0px;
  top: 2px;
}
.box-check-box .check-box-day{
  position: absolute;
  right: 0px;
  top: 2px;
}
</style>